import { createSlice } from '@reduxjs/toolkit';

export const viewImagesSlice = createSlice({
	name: 'viewImages',
	initialState: {
		data: [],
	},
	reducers: {
		setViewImages: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { setViewImages } = viewImagesSlice.actions;
export default viewImagesSlice.reducer;
